<template>
  <section class="s-strip--small s-breadcrumb">
    <div class="container">
      <ul>
        <li v-for="(item, index) in links" :key="index">
          <a :href="item.href" :aria-label="ariaLabel(item)">
            <img v-if="item.icon" :src="item.icon" :alt="item.name" />
            {{ item.icon ? '' : item.name }}
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    links: {
      default() {
        return []
      },
      type: Array,
    },
  },
  methods: {
    ariaLabel(item) {
      return `navigate to ${item.name}`
    },
  },
}
</script>
